import { Link } from 'react-router-dom';
import { pageMeta } from '../../constants/pageMeta';
import { COMPANY_NAME, SITE_DOMAIN, SITE_NAME } from '../../constants/site';
import PolicyPage, { ContactBlock, Section } from '../components/PolicyPage';

const META = pageMeta(
  'Cookie Policy',
  `Which cookies ${SITE_DOMAIN} uses, why, and how to control them.`,
  '/cookie-policy'
);

const COOKIES = [
  ['Strictly necessary', 'Make the website work and keep it secure, for example remembering your menu or form state.', 'Session'],
  ['Analytics', 'Count visits and see which pages are used so we can improve the website.', 'Up to 2 years'],
  ['Advertising & conversion', 'Set by advertising partners such as Google to measure whether people who saw or clicked our ads visited, called or sent a request, and where permitted to show our ads on other sites.', 'Up to 13 months'],
];

export default function CookiePolicyPage() {
  return (
    <PolicyPage
      title="Cookie Policy"
      meta={META}
      intro={`This policy explains how ${COMPANY_NAME} (${SITE_NAME}) uses cookies and similar technologies on ${SITE_DOMAIN}.`}
    >
      <Section title="1. What cookies are">
        <p>
          Cookies are small text files stored on your device when you visit a website. Similar technologies include
          pixels, tags and local storage. We call all of these “cookies” in this policy.
        </p>
      </Section>

      <Section title="2. Cookies we use">
        <div className="fx-table">
          <table>
            <thead>
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Purpose</th>
                <th scope="col">How long</th>
              </tr>
            </thead>
            <tbody>
              {COOKIES.map(([type, purpose, life]) => (
                <tr key={type}>
                  <th scope="row">{type}</th>
                  <td>{purpose}</td>
                  <td>{life}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>

      <Section title="3. Third-party cookies">
        <p>
          Some cookies are set by third parties, such as Google, when they provide analytics or advertising services
          to us. Those parties process data under their own privacy policies. See{' '}
          <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">
            how Google uses cookies
          </a>
          .
        </p>
      </Section>

      <Section title="4. How to control cookies">
        <p>
          You can block or delete cookies in your browser settings, and most browsers let you send a “Do Not Track” or
          Global Privacy Control signal, which we treat as a request to opt out of advertising cookies where the law
          requires. You can manage Google ad personalisation at{' '}
          <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">
            adssettings.google.com
          </a>
          . Blocking strictly necessary cookies may stop parts of the website working.
        </p>
      </Section>

      <Section title="5. More information">
        <p>
          For how we handle personal information generally, see our <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>
        <ContactBlock />
      </Section>
    </PolicyPage>
  );
}
